import DollarsIcon from './DollarsIcon';

export default DollarsIcon;
